export default __webpack_public_path__ + "static/media/pop-cracker.dbdc7edd.svg";